import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'displayInsureFor'
})
export class DisplayInsureForPipe implements PipeTransform {

  constructor(
    private translate: TranslateService,
  ) { }

  transform(value: any, args?: any): any {
    let key = '';
    if (value === 'Self') {
      key = 'insurer.for.self';
    } else if (value === 'Other') {
      key = 'insurer.for.other';
    }

    return key === '' ? value : this.translate.get(key);
  }

}
